import React, { Component } from "react";
import { Grid, Box, CardContent, CardMedia } from "@mui/material";
import CtTxt from "./CustomTool/CtTxt";
import CtDtp from "./CustomTool/CtDtp";
import CtTxtAmt from "./CustomTool/CtTxtAmt";
import CtTxtNum from "./CustomTool/CtTxtNum";
import CtCmb from "./CustomTool/CtCmb";
import TextAreaAutoSize from "./CustomTool/TextAreaAutoSize";
import CtBtn from "./CustomTool/CtBtn";
import { Edit, Delete, ThirtyFpsSharp } from "@mui/icons-material";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import { withRouter } from "../HOC/withRouter";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import { connect } from "react-redux";
import Progress from "./CustomTool/Progress";
import {
  mapStatetoProps,
  mapSetActiveMenuToProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import { fetchLoadUnload, fetchPlaceDetail } from "./API";
import {
  get_YMD_from_SYS,
  get_30DaysBack_FromCurrentDate,
  isValidItem,
  getlocalstoragedate,
  setlocalstoragedate,
  applyTrimOnObjectValues,
  csvFileName,
} from "../SystemUtility/SystemUtility";
import TableList from "./CustomTool/TableList";
import VehicleUnload from "./VehicleUnload";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import ResetDate from "../images/resetdate.png";
import MaterialTable from "./CustomTool/MaterialTable";
import CustomerMaster from "./CustomerMaster";
import LedgerMaster from "./LedgerMaster";
import TripItemEntry from "./TripItemEntry";
import CtART from "./CustomTool/ResponsiveTable";

class DriverMaster extends Component {
  state = {
    formData: {
      txtPlaceName: "",
      bint_srno: "",
    },

    columnsdata: [
      {
        accessorKey: "bint_srno",
        header: "Sr no.",
      },
      {
        accessorKey: "vac_placename",
        header: "Place Name",
      },
    ],
    rows: [],

    rowsCount: 0,
    rowsPerPage: 50,
    counter: 0,

    dataLoadStatus: true,
    ARD: null,
  };

  //#region Component
  componentDidMount() {
    {
      !this.props.showHeading &&
        (document.title = "RiTe Account : Place Master");
    }
    this.props.setActiveMenu("PlaceMaster");
    this.props.verifyUserID(
      this.onFormLoad,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
  }
  //#endregion Component

  //#region Handle

  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };
  handleChangeRowsPerPageOtherDetail = (rowsPerPageOtherDetail) => {
    this.setState({ rowsPerPageOtherDetail });
  };

  handleARDonActionClick_Delete = (row) => {
    const bint_srno = row.getValue("bint_srno"),
      Place = row.getValue("vac_placename");
    this.DeleteData(bint_srno, Place);
  };

  DeleteData = (bint_srno, Place) => {
    if (bint_srno > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={"Do you want to Delete Place Name : " + Place + " ?"}
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeletePlace(bint_srno);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );

        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("Select a record for deletion.");
    }
  };

  DeletePlace = (bint_srno) => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "DeletePlace",
      bint_acid: localStorage.getItem("acid"),
      bint_srno: bint_srno,
      // bol_list: true,
    };
    fetchPlaceDetail(reqData)
      .then((res) => {
        this.props.updateProcessing(res.data.msgType, res.data.message);
        if (res.data.msgType === "success") {
          let rows = [],
            rowsCount = rows.length;
          if (res.data.PlaeList && res.data.PlaeList.length > 0) {
            rows = res.data.PlaeList;
            rowsCount = rows.length;
          }
          this.setState(
            {
              rows,
              rowsCount,
              ARD: null,
            },
            () => {
              this.onFormLoad();
              this.clearInfo();
            }
          );
          document.getElementById("txtPlaceName").focus();
        }
      })
      .catch((error) => {
        this.props.updateProcessing(
          "error",
          "Unknown error occurred in delete Check list. " + error
        );
      });
    return false;
  };

  handleARDonActionClick_Edit = (row) => {
    console.log("row", row);
    // console.log('row.original["bint_srno"]', row.original["bint_srno"]);
    const bint_srno = row.getValue("bint_srno"),
      txtPlaceName = row.getValue("vac_placename");
    // const rows2 = row.original.CheckToDoList;
    // console.log("rows2", rows2);
    this.setState({
      formData: {
        ...this.state.formData,
        bint_srno,
        txtPlaceName,
      },
    });
    window.scrollTo(0, 0);
    document.getElementById("txtPlaceName").focus();
  };

  handleOnNewEntryClick = () => {
    let ARD = null;
    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          // New : Sales Item Entry'
          alertMessage={<TripItemEntry />}
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );
      this.setState({ ARD });
    });
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  handleOnRowDataChange = (rows, handledRowIndex, colID) => {
    this.setState({ rows, rowsCount: rows.length }, () => {});
  };

  //#endregion handle

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
      // excludeKeysArray: [""],
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  onFormLoad = () => {
    let dataLoadStatus = false;
    this.setState({ dataLoadStatus }, () => {
      const reqData = {
        Op: "LoadPlace",
        bint_acid: localStorage.getItem("acid"),
      };
      fetchPlaceDetail(reqData)
        .then((res) => {
          dataLoadStatus = true;
          let rows = [],
            rowsCount = 0;
          if (res.data.PlaceList && res.data.PlaceList.length > 0) {
            rows = res.data.PlaceList;
            rowsCount = rows.length;
          }
          this.setState(
            {
              dataLoadStatus,
              rows,
              rowsCount,
            }
            // () => {
            //     if (this.props.refreshGroupNameList) {
            //         this.props.refreshGroupNameList(rows);
            //     }
            // }
          );
        })
        .catch((error) => {
          console.log("Unknown error occurred in onFormLoad.", error);
        });
    });
    document.getElementById("txtPlaceName").focus();
  };

  clearInfo = () => {
    let bint_srno = "",
      txtPlaceName = "";
    this.setState(
      {
        formData: {
          ...this.state.formData,
          bint_srno,
          txtPlaceName,
        },
      },
      () => {
        document.getElementById("txtPlaceName").focus();
      }
    );
  };

  validatPlaceMaster = () => {
    let result = false;
    if (this.state.formData.txtPlaceName.length <= 0) {
      this.props.toastErrorMsg("Enter Place Name", "txtPlaceName");
    } else {
      result = true;
    }
    return result;
  };

  SavePlace = () => {
    this.trimFormData(() => {
      if (this.validatPlaceMaster()) {
        let dataLoadStatus = false;
        this.props.notifyProcessing();
        this.setState({ dataLoadStatus }, () => {
          const reqData = {
            Op: "SavePlace",
            bint_acid: localStorage.getItem("acid"),
            bint_srno: this.state.formData.bint_srno,
            vac_placename: this.state.formData.txtPlaceName
              .trim()
              .split(" ")
              .map(
                (word) =>
                  word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
              )
              .join(" "),
          };
          fetchPlaceDetail(reqData)
            .then((res) => {
              this.props.updateProcessing(res.data.msgType, res.data.message);
              dataLoadStatus = true;
              let rows = this.state.rows,
                rowsCount = rows.length;
              if (res.data.msgType === "success") {
                if (res.data.PlaceList && res.data.PlaceList.length > 0) {
                  rows = res.data.PlaceList;
                  rowsCount = rows.length;
                }
              }
              this.setState(
                {
                  dataLoadStatus,
                  rows,
                  rowsCount,
                },

                () => {
                  if (res.data.msgType === "success") {
                    this.clearInfo();
                  }
                }
              );
            })
            .catch((error) => {
              console.log(
                "Unknown error occurred in SaveReferenceMaster.",
                error
              );
            });
        });
      }
    });
  };
  handleOnList = () => {};

  render() {
    return (
      <form>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />
        {this.props.showHeading == true && (
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            className="title"
          >
            <label
              htmlFor="Title"
              style={{ fontSize: "25px", color: "#6f7689" }}
            >
              <b>Place Master</b>
            </label>
          </Grid>
        )}

        <Grid
          container
          direction="column"
          spacing={2}
          // marginTop={0}
          justifyContent="center"
          alignItems="center"
        >
          <Grid item>
            <Grid
              container
              direction="row"
              spacing={2}
              marginTop={0}
              justifyContent="center"
              alignItems="flex-start"
            >
              <Grid item>
                <CtTxt
                  id="txtPlaceName"
                  value={this.state.formData.txtPlaceName}
                  handleOnChange={this.handleOnChange}
                  label="Place Name*"
                  width={250}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  defaultAction={this.SavePlace}
                />
              </Grid>

              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="flex-start"
                spacing={2}
                margin={1}
              >
                <Grid item>
                  <CtBtn label="Save" onClick={this.SavePlace} />
                </Grid>

                <Grid item>
                  <CtBtn
                    label="New"
                    onClick={this.clearInfo}
                    variant={"outlined"}
                  />
                </Grid>
                <Grid item>
                  <CtBtn
                    label="Delete"
                    onClick={() => {
                      this.DeleteData(
                        this.state.formData.bint_srno,
                        this.state.formData.txtPlaceName
                      );
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <br />

        <Grid item marginTop={3} className="maintable">
          <CtART
            rowsdata={this.state.rows}
            columnsdata={this.state.columnsdata}
            rowsPerPage={this.state.rowsPerPage}
            tblmaxHeight={500}
            csvFileName={csvFileName("PlaceMaster")}
            rowIconAction={[
              {
                label: "Edit",
                onClick: this.handleARDonActionClick_Edit,
                icon: "Edit",
                className: "secondary-button",
              },
              {
                label: "Delete",
                onClick: this.handleARDonActionClick_Delete,
                icon: "delete",
                className: "delete-button",
              },
            ]}
            showColumnFilters={false}
            actionColSize={10}
            hideColIdList={["bint_srno"]}
            density={"compact"}
          />
        </Grid>
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(DriverMaster))));
